import React from 'react';

import AvailabilityForm from './AvailabilityForm';
import {
  useUpdateProviderAvailabilityMutation
} from '../../redux/services/providerAvailabilityApi';

const handleSubmit = ({put, id, afterSubmit}) => async formData => {
  const body = formData;
  const response = await put({id, body});
  if (response?.error) {
    console.error(new Error(response.error?.data?.errors?.[0]));
    return Promise.reject(response.error?.data?.errors?.[0]);
  }
  if (afterSubmit) afterSubmit();
  return Promise.resolve(response);
};

const EditAvailabilityForm = ({
  availability,
  afterSubmit,
}) => {
  const [put] = useUpdateProviderAvailabilityMutation();
  if (!availability) return <></>;
  return (
    <AvailabilityForm
      availability={availability}
      editing={true}
      onSubmit={handleSubmit({put, id: availability.id, afterSubmit})}
    />
  );
};

export default EditAvailabilityForm;